import React from 'react';
import styles from './SubjectStatusView.module.scss';
import { Form } from 'antd';
import DropdownSelect from '../../../../../../components/dropdownSelect';
import { getDocOptionsSelect } from '../../../../utils/getDocOptionsSelect';
import { useDispatch, useSelector } from 'react-redux';
import useDocsSubtypesQuery from '../../../../queries/useDocsSubtypesQuery';
import DispexInput, {
  typeInput,
} from '../../../../../../components/DispexInput';
import {
  applySubtypes,
  applyTopic,
  applyTopicIds,
} from '../../../../store/actions/documentFilterNew.actions';
import { docTypes } from '../../../../constants/documents.constants';
import useDocsAppealTopicsQuery from '../../../../queries/useDocsAppealTopicsQuery';
import useDocsTopicsQuery from '../../../../queries/useDocsTopicsQuery';

const SubjectStatusView = () => {
  const { topic, topicIds, subtypes, typeId } = useSelector(
    (state) => state.documentFilterNewStore
  );

  const { data: subtypesData = [], isFetching: isSubtypesFetching } =
    useDocsSubtypesQuery(typeId, {
      enabled: !!typeId,
    });

  const {
    data: appealTopicsData = [],
    isFetching: isDocsAppealTopicsFetching,
  } = useDocsAppealTopicsQuery({
    staleTime: Infinity,
  });

  const { data: topicsData = [], isFetching: isDocsTopicsFetching } =
    useDocsTopicsQuery({
      staleTime: Infinity,
    });

  const isFetchingTopics = isDocsAppealTopicsFetching || isDocsTopicsFetching;

  const optionsTopic = getDocOptionsSelect(
    typeId === docTypes.citizenAppeal ? appealTopicsData : topicsData
  );

  const showView = typeId !== docTypes.citizenAppeal;

  const dispatch = useDispatch();

  const handleChangeTopic = (value) => {
    dispatch(applyTopic(value));
  };

  const handleChangeSubtypes = (value) => {
    dispatch(applySubtypes(value));
  };

  const handleChangeTopicIds = (value) => {
    dispatch(applyTopicIds(value));
  };

  return (
    <div>
      <Form.Item
        label="Темы"
        style={{ margin: 0 }}
      >
        <DropdownSelect
          value={topicIds}
          disabled={isFetchingTopics}
          loading={isFetchingTopics}
          multiple={true}
          options={getDocOptionsSelect(optionsTopic)}
          onChange={(value) => handleChangeTopicIds(value)}
        />
      </Form.Item>
      <Form.Item
        label="Произвольная тема"
        style={{ margin: 0 }}
      >
        <DispexInput
          placeholder="Произвольная тема"
          typeInput={typeInput.input}
          style={{
            width: '100%',
            height: '40px',
          }}
          value={topic}
          onChange={(value) => handleChangeTopic(value.target.value)}
        />
      </Form.Item>
      {showView && (
        <Form.Item
          label="Вид"
          className={styles.itemForContent}
        >
          <DropdownSelect
            disabled={isSubtypesFetching}
            loading={isSubtypesFetching}
            multiple={true}
            options={getDocOptionsSelect(subtypesData)}
            value={subtypes}
            onChange={(value) => handleChangeSubtypes(value)}
          />
        </Form.Item>
      )}
    </div>
  );
};

export default SubjectStatusView;
